import { getQuarantine, putQuarantine } from '@/services/globalQuarantine';
// fetch and format quarentine days
export const fetchDataQuarantineDays = () => getQuarantine().then(response => formatQuarantineDaysResponse(response?.data));
const formatQuarantineDaysResponse = (response) => ({
    data: response?.data,
    errors: response?.errors,
    success: response?.success,
});
// fetch and format quarentine days put method
export const fetchPutQuarantineDays = (params) => putQuarantine(params).then(response => formatPutQuarantineDaysResponse(response?.data));
const formatPutQuarantineDaysResponse = (response) => ({
    data: response?.data,
    errors: response?.errors,
    success: response?.success,
});
